import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/material';
import theme from './theme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import MethodHero from './components/method/MethodHero';
import MethodFamilies from './components/method/MethodFamilies';
import MethodApproaches from './components/method/MethodApproaches';
import MethodPhilosophy from './components/method/MethodPhilosophy';
import CtaBanner from './components/home/CtaBanner';
import CustomCursor from './components/home/CustomCursor';
import { useCapability } from './components/home/three/useCapability';

const JSON_LD_ID = 'method-page-jsonld';

// Route-specific structured data for GEO/SEO — index.html only carries
// site-wide JSON-LD, so this page injects its own Article block on mount
// and removes it on unmount (same pattern, scoped to this route).
function useMethodJsonLd() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = JSON_LD_ID;
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: "Il metodo Sinergie Generative: come funziona",
      description: 'Le 5 famiglie di pensiero, i 3 approcci strutturati per usare il mazzo di carte, e come il mentor AI le mette in pratica.',
      url: 'https://aicards.ai/metodo',
      inLanguage: 'it-IT',
      isPartOf: { '@type': 'WebSite', name: 'Sinergie Generative', url: 'https://aicards.ai/' },
    });
    document.head.appendChild(script);
    return () => { script.remove(); };
  }, []);
}

function Method() {
  useMethodJsonLd();
  const capability = useCapability();

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{
        bgcolor: theme.home.paper, color: theme.home.ink,
        ...(capability.renderCursor ? { cursor: 'none', '& *': { cursor: 'none !important' } } : {}),
      }}>
        {capability.renderCursor && <CustomCursor />}
        <Navbar />
        <MethodHero />
        <MethodFamilies />
        <MethodApproaches />
        <MethodPhilosophy />
        <CtaBanner />
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default Method;
